import script from "./CoachApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachApplication.vue?vue&type=script&setup=true&lang=js"

import "./CoachApplication.vue?vue&type=style&index=0&id=3c85476a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c85476a"]])

export default __exports__